package org.bsvac.bsvac_kmp.data

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.Instant

class TimeSource {
    private val scope = CoroutineScope(Dispatchers.Default + SupervisorJob())
    var timeString = ""
    var currentTime: Instant = Clock.System.now()
    private val timeJob = scope.launch {
        while (true) {
            currentTime = Clock.System.now()
            timeString = getCurrentLocalTime(currentTime)
            delay(1000)
        }
    }

    private fun getCurrentLocalTime(now: Instant): String {
        val timeZone = TimeZone.currentSystemDefault()
        val localDateTime = now.toLocalDateTime(timeZone)
        val hour = if (localDateTime.hour < 10) {
            "0${localDateTime.hour}"
        } else {
            localDateTime.hour
        }
        val minute = if (localDateTime.minute < 10) {
            "0${localDateTime.minute}"
        } else {
            localDateTime.minute
        }
        val second = if (localDateTime.second < 10) {
            "0${localDateTime.second}"
        } else {
            localDateTime.second
        }
        return "$hour:$minute:$second"
    }
}